import { SGP_MARKET_TYPES } from "../constants/sgpMarketTypes"
import { getTitleText } from "./marketsV2"

// Generic helper function to identify SGP markets
export const isSgpMarket = (market: any): boolean => {
  return (
    market?.type?.startsWith("sgpBuilder") ||
    market?.marketName?.toLowerCase().includes("sgp") ||
    market?.marketName === "SGP"
  )
}

// Helper function to check if a market has valid combined positions for SGP
export const hasValidSgpCombinedPositions = (market: any): boolean => {
  return (
    market?.combinedPositions &&
    (market.combinedPositions[0] ||
      market.combinedPositions[market?.displayPosition || 0] ||
      market.combinedPositions[market?.position || 0]) &&
    Array.isArray(
      market.combinedPositions[0] ||
        market.combinedPositions[market?.displayPosition || 0] ||
        market.combinedPositions[market?.position || 0]
    )
  )
}

// Helper function to get market type description
export const getMarketTypeDescription = (typeId: number): string => {
  switch (typeId) {
    // Winner markets
    case SGP_MARKET_TYPES.WINNER:
      return "Winner"
    case SGP_MARKET_TYPES.WINNER_1ST_HALF:
      return "1st Half Winner"
    case SGP_MARKET_TYPES.WINNER_2ND_HALF:
      return "2nd Half Winner"

    // Total markets
    case SGP_MARKET_TYPES.TOTAL:
      return "Total"
    case SGP_MARKET_TYPES.TOTAL_1ST_HALF:
      return "1st Half Total"
    case SGP_MARKET_TYPES.TOTAL_2ND_HALF:
      return "2nd Half Total"

    // Spread markets
    case SGP_MARKET_TYPES.SPREAD:
      return "Spread"
    case SGP_MARKET_TYPES.SPREAD_1ST_HALF:
      return "1st Half Spread"
    case SGP_MARKET_TYPES.SPREAD_2ND_HALF:
      return "2nd Half Spread"

    // Other markets
    case SGP_MARKET_TYPES.BOTH_TEAMS_TO_SCORE:
      return "Both teams to score"
    case SGP_MARKET_TYPES.DOUBLE_CHANCE:
      return "Double chance"
    case SGP_MARKET_TYPES.DRAW_NO_BET:
      return "Draw no bet"
    case SGP_MARKET_TYPES.CORRECT_SCORE:
      return "Correct score"

    // Player props
    case SGP_MARKET_TYPES.PLAYER_POINTS:
      return "Player points"
    case SGP_MARKET_TYPES.PLAYER_REBOUNDS:
      return "Player rebounds"
    case SGP_MARKET_TYPES.PLAYER_ASSISTS:
      return "Player assists"
    case SGP_MARKET_TYPES.PLAYER_THREES:
      return "Player threes"
    case SGP_MARKET_TYPES.PLAYER_DOUBLE_DOUBLE:
      return "Player double-double"
    case SGP_MARKET_TYPES.PLAYER_TRIPLE_DOUBLE:
      return "Player triple-double"

    // Football specific
    case SGP_MARKET_TYPES.GOAL_SCORER:
      return "Goal scorer"
    case SGP_MARKET_TYPES.SHOTS_ON_GOAL:
      return "Shots on goal"
    case SGP_MARKET_TYPES.CORNERS:
      return "Corners"
    case SGP_MARKET_TYPES.CARDS:
      return "Cards"

    // Tennis specific
    case SGP_MARKET_TYPES.SET_WINNER:
      return "Set winner"
    case SGP_MARKET_TYPES.GAME_WINNER:
      return "Game winner"
    case SGP_MARKET_TYPES.ACE_COUNT:
      return "Ace count"

    // Baseball specific
    case SGP_MARKET_TYPES.RUNS:
      return "Runs"
    case SGP_MARKET_TYPES.HITS:
      return "Hits"
    case SGP_MARKET_TYPES.STRIKEOUTS:
      return "Strikeouts"

    // Hockey specific
    case SGP_MARKET_TYPES.GOALS:
      return "Goals"
    case SGP_MARKET_TYPES.SAVES:
      return "Saves"
    case SGP_MARKET_TYPES.PENALTIES:
      return "Penalties"

    default:
      return ""
  }
}

// Helper function to get enhanced SGP text
export const getEnhancedSgpText = (
  combinedPosition: any,
  individualPositionText: string,
  market: any
): { enhancedText: string; subText: string } => {
  // Use the position text from Overtime as the main text
  const enhancedText =
    individualPositionText && individualPositionText !== "-"
      ? individualPositionText
      : `Position ${combinedPosition.position}`

  // Create a market object to get the title text from Overtime
  const marketForTitle = {
    ...market,
    typeId: combinedPosition.typeId,
    line: combinedPosition.line,
    position: combinedPosition.position,
    homeTeam: market.homeTeam,
    awayTeam: market.awayTeam,
    leagueId: market.leagueId,
  }

  // Get the subtext from Overtime's getTitleText function
  const subText = getTitleText(marketForTitle, false, true) // Use short name

  return {
    enhancedText,
    subText,
  }
}
